<template>
	<el-dialog
		:visible.sync="showDialog"
		:show-close="false"
		custom-class="model-wrapper"
		top="0"
	>
		<div 
			class="model-wrapper__title"
			:class="[model ? 'hide' : '']"
		>
			<div>{{ title }}</div>
			<img
				class="hover"
				src="https://i.gsxcdn.com/2126790023_ch95m872.png"
				alt=""
				@click="close"
			/>
		</div>
		<slot></slot>
		<div class="model-wrapper__content" v-if="!model">
			<img src="https://i.gsxcdn.com/2126801920_vb57y11u.png" alt="">
			<span>删除后文件不可找回<br>确定要删除吗？</span>
		</div>
		<div class="model-wrapper__button" v-if="!model">
			<span 
				class="hover"
				@click="cancel"
			>取消</span>
			<span 
				class="confirm hover"
				@click="confirm"
			>确定</span>
		</div>
	</el-dialog>
</template>

<script type="text/javascript">
export default {
	data() {
		return {
			showDialog: false
		};
	},
	props: {
		title: String,
		model: Boolean
	},
	methods: {
		show(options = {}) {
			this.options = options
			this.showDialog = true;
		},
		close() {
			this.showDialog = false
		},
		confirm() {
			this.$emit('success')
			this.close()
			this.options.success && this.options.success()
		},
		cancel() {
			this.$emit('fail')
			this.close()
			this.options.fail && this.options.fail()
		}
	},
	mounted() {

	}
};
</script>

<style lang="less">
.model-wrapper {
	width: 490px;
	background: transparent;
	box-shadow: none;
	transform: translateY(-50%);
	top: 50%;
	.el-dialog__header {
		display: none;

	}
	.el-dialog__body {
		background: #ffffff;
		border-radius: 16px;
		padding: 0 0 40px;
	}
	&__title {
		display: flex;
		align-items: center;
		height: 50px;
		border-bottom: 1px solid #e4e4e4;
		padding: 0 22px;
		justify-content: space-between;
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #11142d;
		&.hide {
			border-bottom: none;
		}
		img {
			width: 22px;
			height: 22px;
		}
	}
	&__button {
		margin-top: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 24px;
		span {
			width: 120px;
			height: 36px;
			line-height: 36px;
			text-align: center;
			background: #e6f5ff;
			border-radius: 18px;
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #39b0fc;
			&:first-child {
				margin-right: 24px;
			}

		}
		.confirm {
			color: white;
			background: #39B0FC;
		}
	}
	&__content {
		text-align: center;
		margin-top: 30px;
		img {
			width: 48px;
			height: 48px;
			display: block;
			margin: 0 auto;
			margin-bottom: 14px;
		}
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #585A6C;
		line-height: 28px;
	}
}
</style>
